import type { ReceiptChannel } from '@chukua/common';
import { Form, Input } from 'antd';
import { referenceHintFor } from '../policies/reference-hint';

/** Hidden until a channel is chosen, because what the reference is, and whether it is needed, depends on the channel. */
export function ReceiptReferenceField() {
  const channel = Form.useWatch<ReceiptChannel | undefined>('channel');
  if (!channel) return null;

  const { label, hint, isRequired } = referenceHintFor(channel);

  return (
    <Form.Item name="reference" label={label} extra={hint} rules={[{ required: isRequired, whitespace: true, message: `Enter the ${label.toLowerCase()}` }]}>
      <Input />
    </Form.Item>
  );
}
